import React from "react";
import { usePermissions } from "../../../context/PermissionsContext";
import { useOrganizationFeatures } from "../../../context/OrganizationFeaturesContext";
import InlineAlert from "../../UI/DesignStandards/Notifications/InlineAlert";
import { SkeletonBoard } from "../../UI/DesignStandards";
import { FEATURE_CHECK_PRINTING } from "../../../utility/features";

const CheckTemplatesGate = ({ children }) => {
  const { canManageTournaments } = usePermissions();
  const { hasFeature, ready } = useOrganizationFeatures();

  if (!ready) {
    return (
      <div
        className="space-y-4 sm:space-y-6"
        role="status"
        aria-label="Loading check templates"
      >
        <SkeletonBoard rows={2} />
      </div>
    );
  }

  if (!canManageTournaments || !hasFeature(FEATURE_CHECK_PRINTING)) {
    return (
      <InlineAlert
        type="info"
        title="Check printing is not available"
        message="This organization does not have Check printing."
      />
    );
  }

  return children;
};

export default CheckTemplatesGate;
